export { default as PaymentsContent } from './PaymentsContent/PaymentsContent'
